"use strict";
// @ts-ignore
try {
    self['workbox:strategies:7.0.0'] && _();
}
catch (e) { }
